
// Mock data for voltage regulators
export const mockVoltageRegulators = [
  {
    deviceId: "vr-2034",
    location: "Substation Alpha",
    status: "Warning",
    batteryLevel: 68,
    signalStrength: 75,
    lastCommunication: "2024-06-04T15:32:00Z",
    firmwareVersion: "v2.3.1",
    readings: {
      inputVoltage: 242.3,
      outputVoltage: 230.1,
      current: 15.2,
      frequency: 50.1,
      regulationAccuracy: 98.4,
      responseTime: 50, // milliseconds
    },
    maintenanceStatus: {
      lastMaintenance: "2024-04-15T09:00:00Z",
      nextScheduled: "2024-07-15T09:00:00Z",
      alerts: ["Performance degradation"],
    }
  },
  {
    deviceId: "vr-2035",
    location: "Substation Beta",
    status: "Good",
    batteryLevel: 92,
    signalStrength: 88,
    lastCommunication: "2024-06-05T08:45:10Z",
    firmwareVersion: "v2.3.1",
    readings: {
      inputVoltage: 238.7,
      outputVoltage: 230.0,
      current: 12.8,
      frequency: 50.0,
      regulationAccuracy: 99.7,
      responseTime: 35, // milliseconds
    },
    maintenanceStatus: {
      lastMaintenance: "2024-05-10T11:30:00Z",
      nextScheduled: "2024-08-10T11:30:00Z",
      alerts: [],
    }
  },
  {
    deviceId: "vr-2036",
    location: "Substation Gamma",
    status: "Good",
    batteryLevel: 85,
    signalStrength: 92,
    lastCommunication: "2024-06-05T09:12:45Z",
    firmwareVersion: "v2.3.1",
    readings: {
      inputVoltage: 236.5,
      outputVoltage: 230.2,
      current: 14.5,
      frequency: 50.0,
      regulationAccuracy: 99.2,
      responseTime: 42, // milliseconds
    },
    maintenanceStatus: {
      lastMaintenance: "2024-04-28T14:15:00Z",
      nextScheduled: "2024-07-28T14:15:00Z",
      alerts: [],
    }
  }
];
